import React, { useContext } from 'react'
import { ItemType, Priority, TodoContext } from './Project';
import Todo from './Todo';

export default function TodoResource() {
  const {tasks} = useContext(TodoContext);
  const lines = tasks.filter(task => task.priority === Priority.None && task.itemType === ItemType.Resource);
  
  return ( 
    <Todo title='Resources' lines={lines} titleStyle='titleResources'/> 
  );
}
